import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import CumulativeBarChartTemplate from "views/molecules/charts/template/CumulativeBarChartTemplate"

const DEVICE_COMPONENTS = ["mobile", "tablet", "desktop"]
const translationPrefix = "analyze:websites.device_ghg_breakdown"

const toNumber = (value) => Number(value) || 0

const buildChartData = (ghgBreakdown) => {
  const rows = ghgBreakdown || []

  const periodCo2 = (component, lifecycle) =>
    toNumber(
      rows.find(
        (row) => row.component === component && row.lifecycle === lifecycle
      )?.period_co2
    )

  const components = DEVICE_COMPONENTS.map((component) => ({
    component,
    usage: periodCo2(component, "usage"),
    embodied: periodCo2(component, "embodied"),
  }))
    .map((item) => ({ ...item, total: item.usage + item.embodied }))
    .filter((item) => item.total > 0)

  if (components.length === 0) {
    return null
  }

  return {
    labelKeys: components.map(({ component }) => component),
    datasets: [
      {
        label: "usage",
        data: components.map(({ usage }) => usage),
      },
      {
        label: "embodied",
        data: components.map(({ embodied }) => embodied),
      },
    ],
  }
}

const ChartAnalyzeWebsiteDeviceGhgBreakdown = ({ chart }) => {
  const { t } = useTranslation()

  const chartData = useMemo(
    () => buildChartData(chart?.ghg_breakdown),
    [chart?.ghg_breakdown]
  )

  if (!chartData) {
    return null
  }

  const datasets = chartData.datasets.map((dataset) => ({
    ...dataset,
    label: t(`${translationPrefix}.${dataset.label}`),
  }))

  return (
    <CumulativeBarChartTemplate
      title={t(`${translationPrefix}.title`)}
      helpText={t(`${translationPrefix}.help_devices_only`)}
      datasets={datasets}
      labelPath={`${translationPrefix}.labels`}
      labelKeys={chartData.labelKeys}
      unitPath="units:units.emission"
      unitKey="kg_unit"
      sortDatasets
    />
  )
}

ChartAnalyzeWebsiteDeviceGhgBreakdown.propTypes = {
  chart: PropTypes.object.isRequired,
}

export default ChartAnalyzeWebsiteDeviceGhgBreakdown
